// extracted by mini-css-extract-plugin
module.exports = {"overlay":"search-menu_overlay__A2i4L"};